import helper from '@/libs/helper';


const today = new Date();

const maturityFilter = deal => (deal.maturity_date !== null && deal.maturity_date !== undefined);

const oldDrawsFilter = (deal) => {
  if (!deal.draw_date) { return false; }
  const diffDays = helper.dayDiff(today, new Date(deal.draw_date));
  return deal.holdback_balance > 0.01 && diffDays >= 90;
};

export default {
  maturityFilter,
  oldDrawsFilter,
  isInProgress: loan => loan.group === 'in_progress',
  isActive: loan => loan.group === 'active',
  isPaid: loan => loan.group === 'paid',

  isDealAbleToRequestExtension: loan => loan.extension_requests !== null,
};



// WEBPACK FOOTER //
// ./src/libs/deals.js